<template>
	<div class="-search-sticky" data-scroll data-scroll-repeat>
		<div class="c-programmes-search u-bg-color-6 -search-margin-top">
			<div class="o-container">
				<div class="o-form">
					<div class="o-form__item__container">
						<div class="o-form__item">
							<label class="o-label sr-only" for="programmes-search">{{ t("Mots clés") }}</label>
							<input @keyup="keyupSearch()" @keyup.enter="refreshUrlQuery()" class="o-input" id="programmes-search" type="text" :placeholder="t('Mots clés')" v-model="searchInput">
							<svg class="o-ico -ico-search" role="img">
								<title>search</title>
								<use xlink:href="/assets/img/sprite.svg?v=2#search"></use>
							</svg>
						</div>
						<div v-if="years.length>0" class="o-form__item">
							<label class="o-label sr-only" for="year">{{ t("Année") }}</label>
							<select @change="changeSelectionYear()" class="o-select" id="year" v-model="selectedYear">
								<option value="">{{ t("Année") }}</option>
								<option v-for="year in years" :value="year">{{ year }}</option>
							</select>
							<svg class="o-ico -ico-arrow-down" role="img">
								<title>arrow-down</title>
								<use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
							</svg>
						</div>
						<div v-if="jesuis.length>0" class="o-form__item">
							<label class="o-label sr-only" for="target">{{ t("Je suis") }}</label>
							<select @change="changeSelectionTarget()" ref="target" class="o-select" id="target" v-model="selectedJe">
								<option value="">{{ t("Je suis") }}</option>
								<option v-for="je in jesuis" :value="je.id">{{ je.title }}</option>
							</select>
							<svg class="o-ico -ico-arrow-down" role="img">
								<title>arrow-down</title>
								<use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
							</svg>
						</div>
						<div v-if="enseignants.length>0" class="o-form__item">
							<label class="o-label sr-only" for="theme">{{ t("Corps enseignants") }}</label>
							<select @change="changeSelectionEnseignant()" ref="theme" class="o-select" id="theme" v-model="selectedEnseignant">
								<option value="">{{ t("Corps enseignants") }}</option>
								<template v-for="enseignant in enseignants">
									<option :value="enseignant.id">{{ enseignant.title }}</option>
								</template>
							</select>
							<svg class="o-ico -ico-arrow-down" role="img">
								<title>arrow-down</title>
								<use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
							</svg>
						</div>
						<div v-if="categories.length>0" class="o-form__item">
							<label class="o-label sr-only" for="theme">{{ t("Thématiques") }}</label>
							<select @change="changeSelectionCategory()" ref="theme" class="o-select" id="theme" v-model="selectedCategory">
								<option value="">{{ t("Thématiques") }}</option>
								<template v-for="category in categories">
									<option v-if="category.parent === null" :value="category.id">{{ category.title }}</option>
									<template v-if="category.parent === null && hasChilds(category)" v-for="child in categories">
                                        <option v-if="child.parent === category.id" :value="child.id">&mdash; {{ child.title }}</option>
                                        <template v-if="child.parent === category.id && hasChilds(child)" v-for="children in categories">
                                            <option v-if="children.parent === child.id" :value="children.id">&mdash;&mdash; {{ children.title }}</option>
                                        </template>
                                    </template>
								</template>
							</select>
							<svg class="o-ico -ico-arrow-down" role="img">
								<title>arrow-down</title>
								<use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
							</svg>
						</div>
						<div v-if="formats.length>0" class="o-form__item">
							<label class="o-label sr-only" for="format">{{ t("Formats") }}</label>
							<select @change="changeSelectionFormat()" ref="format" class="o-select" id="format" v-model="selectedFormat">
								<option value="">{{ t("Formats") }}</option>
								<option v-for="format in formats" :value="format.id">{{ format.title }}</option>
							</select>
							<svg class="o-ico -ico-arrow-down" role="img">
								<title>arrow-down</title>
								<use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
							</svg>
						</div>
						<div class="o-form__button c-tooltip__wrap">
							<button class="o-button -button-bg js-advanced-search-button"
								@click.prevent="toggleAdvancedSearch"
								aria-label="Ouvrir et/ou fermer la recherche"
							>
								<span class="o-button__icos">
									<span class="o-button__ico">
										<svg class="o-ico -ico-search-category" role="img">
											<title>search-category</title>
											<use xlink:href="/assets/img/sprite.svg?v=2#search-category"></use>
										</svg>
									</span>
									<span class="o-button__ico">
										<svg class="o-ico -ico-search-category" role="img">
											<title>search-category</title>
											<use xlink:href="/assets/img/sprite.svg?v=2#search-category"></use>
										</svg>
									</span>
								</span>
								<span v-if="target===null" class="o-button__text">
									<span class="o-button__text__elm">
										{{ t("Recherche avancée") }} <span class="sr-only">{{ t("pour trouver un article") }}</span>
									</span>
								</span>
								<span v-else class="o-button__text">
									<span class="o-button__text__elm">
										{{ t("Rechercher") }} <span class="sr-only">{{ t("pour trouver un article") }}</span>
									</span>
								</span>
							</button>
							<div class="c-tooltip">
								<span v-if="target===null" class="c-tooltip__text">
									{{ t("Voir les") }} {{ results }} {{ t("résultats") }}
								</span>
								<span v-else class="c-tooltip__text">
									{{ t("Voir les") }} {{ t("résultats") }}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
    <div v-if="tags.length>0 || searchInput.length>0" class="c-programmes-search__filters">
        <div class="o-container">
            <div class="c-programmes-search__filters__wrap">
                <div v-if="target===null" class="c-programmes-search__filters__total">
                    <span>
                        {{ results }} {{ t("résultats") }}
                    </span>
                </div>
                <div class="c-programmes-search__filters__actives">
                    <div v-for="tag in tags" class="c-programmes-search__filters__actives__item">
                        <span>
                            {{ tag.title }}
                        </span>
                        <button class="c-programmes-search__filters__remove" @click.prevent="removeTag(tag)">
                            <span></span>
                            <span></span>
                            <span class="sr-only">{{ t("Retirer le filtre") }} : {{ tag.title }}</span>
                        </button>
                    </div>
                </div>
                <div v-if="tags.length>0 || searchInput.length>0" class="c-programmes-search__filters__reset">
                    <button class="o-button -button-reset" @click.prevent="resetSearch">
                        {{ t("Réinitialiser la recherche") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="c-loader"></div>
</template>

<script>
    import debounce from 'debounce';

    export default {
        name: 'BlogSearch',
        props: {
            target: {
                type: String,
                default: null
            },
        },
        data() {
            return {
                searchInput: '',
                siteId: 1,
                years: [],
                jesuis: [],
                formats: [],
                categories: [],
                enseignants: [],
                selectedYear: '',
                selectedJe: '',
                selectedFormat: '',
                selectedCategory: '',
                selectedEnseignant: '',
                selectedYears: [],
                selectedJesuis: [],
                selectedFormats: [],
                selectedCategories: [],
                selectedEnseignants: [],
                results: 0,
                controller: null,
                languageUrl: '/',
            }
        },
        mounted() {
            let lang = document.documentElement.lang;
            if (lang === 'fr-CA') {
                this.siteId = 1;
            } else {
                this.siteId = 2;
                this.languageUrl = '/en/';
            }

            let featured = document.querySelector('.js-articles-featured');
            //console.log(featured)
            if (!featured) {
                let tohide = document.querySelectorAll('.hide-on-filter');
                tohide.forEach(element => {
                    element.classList.add('hidden')
                    //console.log(element)
                });
            }

            if (this.target===null) {
                this.emitter.on('emitReset', this.resetSearch);
                this.emitter.on('requestSelectedAttributes', this.emitSelectedAttributes);
                this.emitter.on('updateSelectedAttributes', (data) => {
                    this.selectedYears = data.years;
                    this.selectedCategories = data.categories;
                    this.selectedEnseignants = data.enseignants;
                    this.selectedJesuis = data.jesuis;
                    this.selectedFormats = data.formats;
                    this.searchInput = data.searchInput;
                    this.refreshUrlQuery();
                });
                //load query params
                const currentUrl = new URL(window.location.href);
                const query = currentUrl.search;
                const urlParams = new URLSearchParams(query);
                if (urlParams.has('years')) {
                    this.selectedYears = urlParams.get('years').split(',');
                }
                if (urlParams.has('categories')) {
                    let split = urlParams.get('categories').split(',');
                    this.selectedCategories = split.map(Number);
                }
                if (urlParams.has('enseignants')) {
                    let split = urlParams.get('enseignants').split(',');
                    this.selectedEnseignants = split.map(Number);
                }
                if (urlParams.has('jesuis')) {
                    let split = urlParams.get('jesuis').split(',');
                    this.selectedJesuis = split.map(Number);
                }
                if (urlParams.has('formats')) {
                    let split = urlParams.get('formats').split(',');
                    this.selectedFormats = split.map(Number);
                }
                if (urlParams.has('s')) {
                    this.searchInput = urlParams.get('s');
                }

                let currentResults = document.querySelector('.js-articles-results');
                this.results = currentResults.dataset.results;
            }

            this.fetchAttributes();
            if (this.target===null) this.emitSelectedAttributes();
        },
        computed: {
            tags() {
                let tags = [];
                if (this.selectedYears.length > 0) {
                    let years = this.years.filter(year => this.selectedYears.includes(year));
                    years.forEach(year => {
                        tags.push({
                            type: 'year',
                            id: year,
                            title: year
                        });
                    });
                }
                if (this.selectedCategories.length > 0) {
                    let categories = this.categories.filter(cat => this.selectedCategories.includes(cat.id));
                    categories.forEach(category => {
                        tags.push({
                            type: 'category',
                            id: category.id,
                            title: category.title
                        });
                    });
                }
                if (this.selectedEnseignants.length > 0) {
                    let enseignants = this.enseignants.filter(enseignant => this.selectedEnseignants.includes(enseignant.id));
                    enseignants.forEach(enseignant => {
                        tags.push({
                            type: 'enseignant',
                            id: enseignant.id,
                            title: enseignant.title
                        });
                    });
                }
                if (this.selectedJesuis.length > 0) {
                    let jesuis = this.jesuis.filter(je => this.selectedJesuis.includes(je.id));
                    jesuis.forEach(je => {
                        tags.push({
                            type: 'jesuis',
                            id: je.id,
                            title: je.title
                        });
                    });
                }
                if (this.selectedFormats.length > 0) {
                    let formats = this.formats.filter(format => this.selectedFormats.includes(format.id));
                    formats.forEach(format => {
                        tags.push({
                            type: 'format',
                            id: format.id,
                            title: format.title
                        });
                    });
                }
                return tags;
            }
        },
        methods: {
            t(string) {
                return BlogLocalisation[string]
            },
            changeSelectionYear() {
                let current = this.selectedYear;
                if (current === '') return;
                if (!this.selectedYears.includes(current)) {
                    this.selectedYears.push(current);
                    if (this.target===null) this.refreshUrlQuery();
                }
                this.selectedYear = '';
            },
            changeSelectionCategory() {
                let current = this.selectedCategory;
                if (current === '') return;
                if (!this.selectedCategories.includes(current)) {
                    this.selectedCategories.push(current);
                    if (this.target===null) this.refreshUrlQuery();
                }
                this.selectedCategory = '';
            },
            changeSelectionEnseignant() {
                let current = this.selectedEnseignant;
                if (current === '') return;
                if (!this.selectedEnseignants.includes(current)) {
                    this.selectedEnseignants.push(current);
                    if (this.target===null) this.refreshUrlQuery();
                }
                this.selectedEnseignant = '';
            },
            changeSelectionTarget() {
                let current = this.selectedJe;
                if (current === '') return;
                if (!this.selectedJesuis.includes(current)) {
                    this.selectedJesuis.push(current);
                    if (this.target===null) this.refreshUrlQuery();
                }
                this.selectedJe = '';
            },
            changeSelectionFormat() {
                let current = this.selectedFormat;
                if (current === '') return;
                if (!this.selectedFormats.includes(current)) {
                    this.selectedFormats.push(current);
                    if (this.target===null) this.refreshUrlQuery();
                }
                this.selectedFormat = '';
            },
            refreshUrlQuery() {
                let query = '';
                if (this.selectedYears.length > 0) {
                    query += 'years=' + this.selectedYears.join(',') + '&';
                }
                if (this.selectedCategories.length > 0) {
                    query += 'categories=' + this.selectedCategories.join(',') + '&';
                }
                if (this.selectedEnseignants.length > 0) {
                    query += 'enseignants=' + this.selectedEnseignants.join(',') + '&';
                }
                if (this.selectedJesuis.length > 0) {
                    query += 'jesuis=' + this.selectedJesuis.join(',') + '&';
                }
                if (this.selectedFormats.length > 0) {
                    query += 'formats=' + this.selectedFormats.join(',') + '&';
                }
                if (this.searchInput) {
                    query += 's=' + this.searchInput;
                }
                const currentUrl = new URL(window.location.href);
                let pathName = currentUrl.pathname;
                pathName = pathName.replace(/(p\d)/, '');
                let newUrl = currentUrl.origin + pathName + '?' + query;
                if (this.target!==null) {
                    newUrl = this.target + '?' + query;
                    window.location.href = newUrl;
                    return;
                } else {
                    window.history.pushState({path:newUrl},'',newUrl);
                    this.emitSelectedAttributes();
                    this.search();
                }
            },
            toggleAdvancedSearch() {
                if (this.target===null) this.emitter.emit('toggleAdvancedSearch');
                else this.refreshUrlQuery();
            },
            fetchAttributes() {
                fetch(this.languageUrl + 'api/search/blog-index?siteId=' + this.siteId, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.years !== undefined) this.years = data.years;
                    if (data.categories !== undefined) this.categories = data.categories;
                    if (data.jesuis !== undefined) this.jesuis = data.jesuis;
                    if (data.formats !== undefined) this.formats = data.formats;
                    if (data.enseignants !== undefined) this.enseignants = data.enseignants;
                    if (this.target===null) this.emitter.emit('fetchBlogAttributes', data);
                })
            },
            emitSelectedAttributes() {
                this.emitter.emit('selectedAttributes', {
                    years: this.selectedYears,
                    categories: this.selectedCategories,
                    enseignants: this.selectedEnseignants,
                    jesuis: this.selectedJesuis,
                    formats: this.selectedFormats,
                    searchInput: this.searchInput,
                    results: this.results
                });
            },
            resetSearch() {
                this.selectedYears = [];
                this.selectedCategories = [];
                this.selectedEnseignants = [];
                this.selectedJesuis = [];
                this.selectedFormats = [];
                this.searchInput = '';
                if (this.target===null) this.refreshUrlQuery();
            },
            hasChilds(category) {
                let hasChild = false
                this.categories.forEach(cat => {
                    if (cat.parent === category.id) {
                        hasChild = true
                    }
                })
                return hasChild
            },
            removeTag(tag) {
                if (tag.type === 'year') {
                    this.selectedYears = this.selectedYears.filter(year => year !== tag.id);
                }
                if (tag.type === 'category') {
                    this.selectedCategories = this.selectedCategories.filter(category => category !== tag.id);
                }
                if (tag.type === 'enseignant') {
                    this.selectedEnseignants = this.selectedEnseignants.filter(enseignant => enseignant !== tag.id);
                }
                if (tag.type === 'jesuis') {
                    this.selectedJesuis = this.selectedJesuis.filter(je => je !== tag.id);
                }
                if (tag.type === 'format') {
                    this.selectedFormats = this.selectedFormats.filter(format => format !== tag.id);
                }
                this.refreshUrlQuery();
            },
            keyupSearch() {
                if (this.target!==null) return;
                this.searchTyping();
            },
            searchTyping: debounce(function(e) {
                this.refreshUrlQuery();
            }, 500),
            search() {
                if (this.target!==null) return;
                if (this.controller !== null) {
                    try {
                        this.controller.abort();
                    } catch (error) {
                        //console.log('ABORT', error)
                    }
                }
                this.controller = new AbortController();
                document.body.classList.add('blog-loading');

                let url = window.location.href
                url = url.replace(/(p\d)/, '');
                try {
                    fetch(url, {
                        method: 'GET',
                        signal: this.controller.signal,
                    })
                    .then(response => response.text())
                    .then(data => {
                        let parser = new DOMParser();
                        let doc = parser.parseFromString(data, 'text/html');
                        let results = doc.querySelector('.js-articles-results');
                        let currentResults = document.querySelector('.js-articles-results');
                        let featured = doc.querySelector('.js-articles-featured');
                        let currentFeatured = document.querySelector('.js-articles-featured');
                        let tohide = document.querySelectorAll('.hide-on-filter');
                        //console.log(tohide)
                        if (featured) {
                            tohide.forEach(element => {
                                element.classList.remove('hidden')
                            });
                            if (!currentFeatured) {
                                tohide[0].insertAdjacentElement('beforebegin', featured);
                            } else {
                                currentFeatured.innerHTML = featured.innerHTML;
                            }
                        } else {
                            tohide.forEach(element => {
                                element.classList.add('hidden')
                            });
                            if (currentFeatured) {
                                currentFeatured.remove();
                            }
                        }
                        let pager = doc.querySelector('.c-pager');
                        currentResults.innerHTML = results.innerHTML;
                        this.results = results.dataset.results;
                        this.controller = null;

                        // hide titlle if no results
                        let title = document.querySelectorAll('.js-title-blog');
                        let noresult = document.querySelectorAll('.no-result-message');
                        if (this.results == '0') {
                            //console.log('HIDE', title)
                            title.forEach(element => {
                                element.classList.add('hidden');
                            });
                            noresult.forEach(element => {
                                element.classList.remove('hidden');
                            });
                        } else {
                            //console.log('SHOW')
                            title.forEach(element => {
                                element.classList.remove('hidden');
                            });
                            noresult.forEach(element => {
                                element.classList.add('hidden');
                            });
                        }

                        document.body.classList.remove('blog-loading');
                        this.emitSelectedAttributes();
                    })
                    .catch(error => {
                        console.log('ERROR', error)
                        document.body.classList.remove('blog-loading');
                    });
                } catch (error) {
                    console.log('ERROR', error)
                    document.body.classList.remove('blog-loading');
                }
            }
        }
    }
</script>